// node 下 setTimeout 返回的是对象, 浏览器里则是数字, 据此区别 runtime
export var IF_NODE = typeof setTimeout(function () {}, 0) !== 'number';
//# sourceMappingURL=if-node.js.map